var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-date-picker',{ref:"pickerDateInput",staticClass:"fix-padding-right",attrs:{"id":_vm.id,"type":"month","format":"MM/yyyy","disabled":_vm.disabled,"editable":_vm.editable,"placeholder":_vm.placeholder},on:{"change":_vm.select},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }